<mc-select-list [dataListId]="dataListId" listClass="mc-list-selectable" [listControl]="listControl">
  <ng-template mcListItem let-target>
    <mat-list-item>
      <mc-target-avatar [disabled]="true" [showPath]="true" [targetPath]="target.Path" size="small" [truncate]="true"></mc-target-avatar>
    </mat-list-item>
  </ng-template>

  <ng-template mcEmptyList>
    <p>No targets found.</p>
  </ng-template>

  <ng-template mcAllItemsLoadedList>
    <p>All targets loaded.</p>
  </ng-template>
</mc-select-list>